<div class="seasons-panel">
    <div class="btns-filters">
        <div class="filters-left">
            <div class="buscador-event container-form d-flex align-items-center borderInput">
                <i class="fal fa-search search-icon pointer-in"></i>
                <input class="input-custom w-100" type="text" placeholder="Buscar temporada"
                    [ngModel]="searchText" (input)="onSearch($any($event.target).value)">
            </div>
            <div class="filter-group">
                <div class="filter-pill" [class.active]="activeFilter !== ''" (click)="statusDropdownOpen = !statusDropdownOpen">
                    <i class="fal fa-signal-bars"></i>
                    <span>{{ activeFilter === 'true' ? 'Activa' : activeFilter === 'false' ? 'Inactiva' : 'Estado' }}</span>
                    <i class="fal fa-chevron-down chevron" [class.open]="statusDropdownOpen"></i>
                </div>
                <div class="filter-dropdown" *ngIf="statusDropdownOpen">
                    <div class="filter-option" [class.selected]="activeFilter === ''" (click)="activeFilter = ''; statusDropdownOpen = false; onFilterChange()">Todas</div>
                    <div class="filter-option" [class.selected]="activeFilter === 'true'" (click)="activeFilter = 'true'; statusDropdownOpen = false; onFilterChange()">Activa</div>
                    <div class="filter-option" [class.selected]="activeFilter === 'false'" (click)="activeFilter = 'false'; statusDropdownOpen = false; onFilterChange()">Inactiva</div>
                </div>
            </div>
            <button class="btn-clear" *ngIf="activeFilter || searchText" (click)="clearFilters()">
                <i class="fal fa-xmark"></i> Limpiar
            </button>
        </div>
        <div class="btns-create">
            <div class="btn-create m-0" (click)="openCreate()">
                <i class="fal fa-plus-circle"></i>
                <p class="m-0">Crear temporada</p>
            </div>
        </div>
    </div>

    <div *ngIf="loadingPage" class="container-lottie">
        <div class="loading-container">
            <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
                containerClass="loading-box"></ng-lottie>
        </div>
    </div>

    <div class="table-events table-panel multiple-lines desktop-view" *ngIf="loaded">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z28" matSort>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Acciones</th>
                <td mat-cell *matCellDef="let s">
                    <div [matMenuTriggerFor]="actionMenu" class="pointer-in d-flex justify-content-center"
                        style="width: 20px;">
                        <i class="icon-option fal fa-ellipsis-vertical"></i>
                    </div>
                    <mat-menu class="options-menu-control-panel" #actionMenu="matMenu">
                        <button mat-menu-item (click)="openPasses(s)"><i class="fal fa-id-card" style="margin-right: 8px;"></i>Ver abonados</button>
                        <button mat-menu-item (click)="openEdit(s)"><i class="fal fa-pen-to-square" style="margin-right: 8px;"></i>Editar</button>
                        <button mat-menu-item (click)="toggleActive(s)">
                            <i class="fal" [ngClass]="s.active ? 'fa-toggle-off' : 'fa-toggle-on'" style="margin-right: 8px;"></i>
                            {{s.active ? 'Desactivar' : 'Activar'}}
                        </button>
                        <button mat-menu-item (click)="deleteSeason(s)" class="delete-action"><i class="fal fa-trash-can" style="margin-right: 8px;"></i>Eliminar</button>
                    </mat-menu>
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header><b><i class="fal fa-tag th-icon"></i> Nombre</b></th>
                <td mat-cell *matCellDef="let s" (click)="openEdit(s)">
                    <span class="link-titulo">{{s.name}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="dates">
                <th mat-header-cell *matHeaderCellDef><b><i class="fal fa-calendar-range th-icon"></i> Vigencia</b></th>
                <td mat-cell *matCellDef="let s">
                    <span class="dates-display">
                        <i class="fal fa-clock" style="margin-right: 4px; opacity: 0.5;"></i>
                        {{getDatesDisplay(s)}}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef><b><i class="fal fa-signal-bars th-icon"></i> Estado</b></th>
                <td mat-cell *matCellDef="let s">
                    <span class="status-badge" [ngClass]="s.active ? 'status-badge--active' : 'status-badge--inactive'">
                        <i class="fa-solid" [ngClass]="s.active ? 'fa-circle-check' : 'fa-circle-xmark'"></i>
                        {{s.active ? 'Activa' : 'Inactiva'}}
                    </span>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <!-- Vista de tarjetas para móvil: las mismas temporadas que la tabla, una por
         tarjeta. -->
    <div class="mobile-view list-cards" *ngIf="loaded">
        <div class="list-card" *ngFor="let s of seasons">
            <div class="card-top">
                <p class="card-title" (click)="openEdit(s)">{{s.name}}</p>
                <div class="card-menu" [matMenuTriggerFor]="cardMenu">
                    <i class="icon-option fal fa-ellipsis-vertical"></i>
                </div>
                <mat-menu class="options-menu-control-panel" #cardMenu="matMenu">
                    <button mat-menu-item (click)="openPasses(s)"><i class="fal fa-id-card" style="margin-right: 8px;"></i>Ver abonados</button>
                    <button mat-menu-item (click)="openEdit(s)"><i class="fal fa-pen-to-square" style="margin-right: 8px;"></i>Editar</button>
                    <button mat-menu-item (click)="toggleActive(s)">
                        <i class="fal" [ngClass]="s.active ? 'fa-toggle-off' : 'fa-toggle-on'" style="margin-right: 8px;"></i>
                        {{s.active ? 'Desactivar' : 'Activar'}}
                    </button>
                    <button mat-menu-item (click)="deleteSeason(s)" class="delete-action"><i class="fal fa-trash-can" style="margin-right: 8px;"></i>Eliminar</button>
                </mat-menu>
            </div>

            <div class="card-rows">
                <div class="card-row">
                    <i class="fal fa-clock"></i>
                    <span class="card-row-value card-row-muted">{{getDatesDisplay(s)}}</span>
                </div>
            </div>

            <div class="card-foot">
                <span class="status-badge" [ngClass]="s.active ? 'status-badge--active' : 'status-badge--inactive'">
                    <i class="fa-solid" [ngClass]="s.active ? 'fa-circle-check' : 'fa-circle-xmark'"></i>
                    {{s.active ? 'Activa' : 'Inactiva'}}
                </span>
            </div>
        </div>
    </div>

    <div *ngIf="loaded && !loadingPage && seasons.length === 0" class="empty-state">
        <i class="fal fa-id-card"></i>
        <p>No hay temporadas configuradas</p>
        <span>Crea tu primera temporada para empezar a dar de alta abonados</span>
    </div>
</div>
